import { Button } from "@mui/material";

export default function DayButton(props) {
  const { day, onClick } = props;

  return (
    <Button
      size={"small"}
      sx={{ padding: 0, borderRadius: 8, minWidth: 35, minHeight: 35 }}
      onClick={onClick}
      value={day.day}
      disabled={day.dayDisabled}
    >
      {day.day}
    </Button>
  );
}
